var map = {
	"./arrow_left.svg": 24785,
	"./arrow_right.svg": 49438,
	"./arrow_right1.svg": 78992,
	"./basestation.svg": 13702,
	"./bindingdevice.svg": 45894,
	"./duplex.svg": 15418,
	"./gps.svg": 458,
	"./jt_down.svg": 69776,
	"./jt_up.svg": 98723,
	"./lang.svg": 16432,
	"./patrol_icon.svg": 39661,
	"./play.svg": 32283,
	"./resetpassword.svg": 20720,
	"./scancode.svg": 95986,
	"./service.svg": 28539,
	"./sos.svg": 19761,
	"./soundrecording.svg": 62103,
	"./suspend.svg": 28968,
	"./time.svg": 54570,
	"./video.svg": 96451,
	"./weil.svg": 60915,
	"./xungeng-serve.svg": 52212,
	"./yuej.svg": 32180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;